const steps = [
  {
    num: '1',
    icon: 'ri-edit-line',
    title: 'JE DÉCRIS',
    detail: 'Matin → Midi → Soir',
    desc: 'Je sélectionne les soins réellement réalisés.',
    chips: null as string[] | null,
  },
  {
    num: '2',
    icon: 'ri-brain-line',
    title: 'COTIDEL ANALYSE',
    detail: null as string | null,
    desc: 'Toutes les règles sont vérifiées automatiquement.',
    chips: ['NGAP', 'BSI', 'Cumuls', 'Exceptions', 'Avenants', 'Majorations', 'Déplacements'],
  },
  {
    num: '3',
    icon: 'ri-check-double-line',
    title: 'COTIDEL COTE',
    detail: 'Votre cotation',
    desc: 'Le moteur explique pourquoi cette cotation est retenue.',
    chips: null as string[] | null,
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 animate-on-scroll">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">
            Comment ça marche
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-3">
            3 étapes. Rien de plus.
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Aussi simple que de décrire votre tournée à un collègue expert.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, idx) => (
            <div
              key={s.num}
              className="relative bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 text-center"
            >
              {idx < steps.length - 1 && (
                <div className="hidden md:flex absolute top-1/2 -right-[17px] -translate-y-1/2 w-8 h-8 rounded-full bg-white border border-background-200 items-center justify-center text-foreground-300 z-10">
                  <i className="ri-arrow-right-line"></i>
                </div>
              )}

              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-500 text-white mb-5">
                <i className={`${s.icon} text-2xl`}></i>
              </div>

              <span className="inline-block text-[11px] font-bold text-accent-600 uppercase tracking-wider mb-2">
                Étape {s.num}
              </span>
              <h3 className="text-lg font-bold font-heading text-foreground-950 mb-2">{s.title}</h3>

              {s.detail && (
                <p className="text-xs font-medium text-foreground-500 mb-3">{s.detail}</p>
              )}

              <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>

              {s.chips && (
                <div className="flex flex-wrap justify-center gap-1.5 mt-4">
                  {s.chips.map((chip) => (
                    <span
                      key={chip}
                      className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-[11px] font-semibold"
                    >
                      {chip}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}